export const decorateWith = (...decorators) => unwrapped =>
  decorators.reduce((component, decorator) => decorator(component), unwrapped);

export function withName(displayName) {
  return Component => {
    Component.displayName = displayName;
    return Component;
  };
}
